// extracted by mini-css-extract-plugin
export default {"content":"ApkCpANkgqqMgR9LqW2R"};